import { isDevMode, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppInterceptor } from './core/interceptors/app.interceptor';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { ToastrModule } from 'ngx-toastr';
import { ChatModule } from './main/chat/chat.module';
import { SettingsModule } from './main/settings/settings.module';

import { AuthModule } from './auth/auth.module';
import { MainModule } from './main/main.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule, DatePipe } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { FaqModule } from './main/faq/faq.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SuccessComponent } from './widgets/success/success.component';
import { NoInternetComponent } from './widgets/no-internet/no-internet.component';
import { CookieService } from 'ngx-cookie-service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { functionalCookies, marketingCookies, essentialCookies, otherTools, fullFrenchLang } from './shared/helpers/cookie.config';
import { environment } from './../environment/environment';
import { NgxCookieConsentModule } from '@localia/ngx-cookie-consent';
const cookieConfig = {
  essentialCookies: essentialCookies,
  functionalCookies: otherTools,
  //marketingCookies: marketingCookies,
  //otherTools: otherTools,
  showEssentialCookies: true,
  showFunctionalCookies: true,
  showOtherTools: false,
  showMarketingCookies: false,
  privacyPolicyUrl: environment.confidential_policy_link,
  imprintUrl: environment.mention_legal_link,
  defaultLanguage: 'fr',
  showLanguageSwitcher: false,
  openerPosition: "right-bottom",
  showCookieDetails: false,
  customLanguage: {
    languageKey: 'fr',
    languageName: 'Français',
    customIconPath: '', // Required
    translations: {
      ...fullFrenchLang,
      title: 'Paramètres de consentement aux cookies',
      text: 'Nous utilisons des cookies pour mieux comprendre vos attentes et vous proposer des contenus adaptés à vos préférences. Ces cookies ne sont pas comestibles, mais ils rendent votre expérience sur notre site plus pertinente. Vous pouvez à tout moment modifier vos préférences en cliquant sur l/icône "Préférences de cookies" située dans le pied de page à droite.'
    }
  }
} as const;
@NgModule({
  declarations: [AppComponent, SuccessComponent, NoInternetComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    ToastrModule.forRoot({
      preventDuplicates: true,
      progressBar: true,
      timeOut: 2000,
    }),
    ChatModule,
    SettingsModule,
    FaqModule,
    AuthModule,
    NgSelectModule,
    HttpClientModule,
    MatTableModule,
    BrowserAnimationsModule,
    MainModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    NgxCookieConsentModule.forRoot(cookieConfig),
  ],
  providers: [
    // Ajoutez DatePipe à la liste des fournisseurs
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppInterceptor,
      multi: true,
    },
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService, // required animations providers
    CookieService
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
